import { HINT_ATTR_DATA } from './constants'

export const getHintAttrNameFormatted = (data: string) => ({
  [HINT_ATTR_DATA.nameAttr]: data
})
